module.exports = __webpack_public_path__ + "img/gratification-operator.2a5e91e4.svg";